module.exports = __webpack_public_path__ + "static/media/logo_baja_sae_brasil.43ff249b.png";